import React, { useEffect, useRef, useState } from "react";
import { host } from "@Services/url";
import { setUrlFormat } from "@Lib/common";

const HistoryIframe = ({ data }) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [src, setSrc] = useState("");

  const storeBrowsingHistory = (browsing) => {
    // 存储新车浏览记录 newcarhistory 按日期
    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

    let history = JSON.parse((localStorage as any).getItem("newcarhistory")) || {};

    if (history && typeof history === "object") {
      Object.keys(history).length > 0 &&
        Object.keys(history).forEach((date) => {
          history[date].list = history[date].list?.filter((item) => item.item_id !== browsing.newKindId);
          if (history[date]?.list?.length === 0) {
            delete history[date];
          }
        });

      if (!history[formattedDate]) {
        history[formattedDate] = {
          date: formattedDate,
          list: [],
        };
      }

      const listItem = {
        item_id: browsing.newKindId,
        date: formattedDate,
        price: browsing.price,
        pic: browsing.pic,
        title: browsing.title,
        url: browsing.url,
      };

      history[formattedDate].list.unshift(listItem);

      if (history[formattedDate].list.length > 30) {
        history[formattedDate].list = history[formattedDate].list.slice(0, 30); //控制數量最多30
      }

      localStorage.setItem("newcarhistory", JSON.stringify(history));

      return JSON.stringify(history);
    }

    return null;
  };

  useEffect(() => {
    // setSrc(`https://www.test.8891.com.tw/index-history.html?origin=${location.host}`)
    setSrc(`${host.www}/index-history.html?origin=${location.host}`);

    const iframeElement = iframeRef.current;

    if (iframeElement) {
      const browsing = {
        newKindId: data.newKindId || "",
        pic: data.thumb,
        price: data.price,
        title: `${data.brandName} ${data.kindName}`,
        url: `${host.c}/${setUrlFormat(data.brandName)}/${setUrlFormat(data.kindName)}/Summary.html`,
      };

      const handleLoad = async () => {
        if (iframeElement.contentWindow) {
          try {
            const historyData = storeBrowsingHistory(browsing);
            iframeElement.contentWindow.postMessage(
              {
                _key: "newcarhistory",
                _value: historyData,
                _method: "set",
              },
              "*",
            );
          } catch (error) {
            console.error("Error posting message to iframe:", error);
          }
        }
      };

      iframeElement.addEventListener("load", handleLoad);
      return () => {
        iframeElement.removeEventListener("load", handleLoad);
      };
    }

    return undefined;
  }, [data]);

  return <iframe id={"HistoryIframe"} src={src} className='none' ref={iframeRef} />;
};

export default HistoryIframe;
